module.exports = __webpack_public_path__ + "texture-bw.d58f4f30eee0d22b13d8.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/assets/img/texture-bw.png
// module id = ../../../../../src/assets/img/texture-bw.png
// module chunks = styles